export default function back2top() {
    const backToTop = document.getElementById('back2top');
    if (!backToTop) return;

    // 1. Gestion de l'affichage avec un Throttle/Debounce via RequestAnimationFrame
    let isScrolling = false;

    const checkScrollPosition = () => {
        // Supporte la majorité des navigateurs pour la position du scroll
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > 100) {
            backToTop.classList.add('is-visible');
        } else {
            backToTop.classList.remove('is-visible');
        }
        isScrolling = false;
    };

    window.addEventListener('scroll', () => {
        if (!isScrolling) {
            window.requestAnimationFrame(checkScrollPosition);
            isScrolling = true;
        }
    }, { passive: true }); // passive: true améliore grandement les performances de scroll

    // Exécution initiale au cas où la page est déjà scrollée au chargement
    checkScrollPosition();

    // 2. Scroll fluide et accessibilité (Focus)
    backToTop.addEventListener('click', (e) => {
        e.preventDefault();

        // Scroll fluide natif
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        // Gestion propre de l'accessibilité sans briser le comportement du lecteur d'écran
        document.body.setAttribute('tabindex', '-1');
        document.body.focus({ preventScroll: true });
        
        // Nettoyage du tabindex après le focus
        document.body.addEventListener('blur', () => {
            document.body.removeAttribute('tabindex');
        }, { once: true });
    });
}